import 'url-search-params-polyfill';
import 'intl-pluralrules';
import smoothscroll from 'smoothscroll-polyfill';

import 'normalize.css';

import '@styles'; // eslint-disable-line import/no-unresolved

const {
  OLY_ENV,
  OLY_WEB_SITES_VERSION,
  OLY_DS_VERSION,
  OLY_ENGINE_API_VERSION,
  OLY_ENGINE_STORE_VERSION,
  OLY_ENGINE_UTILS_VERSION,
} = process.env;

smoothscroll.polyfill();

window.__ENV__ = OLY_ENV;
window.__OLY_CONFIG__ = {};

window.__VERSIONS__ = {
  'oly-engine-api': OLY_ENGINE_API_VERSION,
  'oly-engine-store': OLY_ENGINE_STORE_VERSION,
  'oly-engine-utils': OLY_ENGINE_UTILS_VERSION,
  'oly-ds': OLY_DS_VERSION,
  'oly-web-sites': OLY_WEB_SITES_VERSION,
};
